
import React, { useEffect, useState, useRef, useMemo, useCallback } from 'react';
import { Outlet, useLocation, useParams } from 'react-router-dom';
import apiCalls from 'src/api/apiCalls';
import { Spin } from 'antd';
import moment from 'moment';
import defaultAvathar from "../../../assets/images/default-avatar.jpg";
import WarningMessage from 'src/components/shared/messages/warningMessage ';
import AppTabsComponent from "src/components/shared/appTabsComponent";
import CustomerIdCell from 'src/utils/customerIdCell';
import HeaderComponent from 'src/components/header';
import { badgeColor } from 'src/utils/statusColorsCode';

const CustomerInfo = () => {
    const { id, } = useParams();
    const inputRef = useRef(null);
    const [CustomerDetails, setCustomerDetails] = useState(null);
    const [errorMsg, setErrorMsg] = useState(null);
    const [loader, setLoader] = useState(false);
    const [isCopied, setIsCopied] = useState('');
    const location = useLocation();
    const breadcrumbMapping = {
        customerKyc: "KYC",
        customerTransactions: "Transactions",
        customerCards: "Cards"
    };
    const currentTab = location?.pathname?.split('/')?.pop();
    const tabName = breadcrumbMapping[currentTab] || "KYC";
    useEffect(() => {
        if (id)
            getCustomerDetails();
    }, [id])
    const getCustomerDetails = async () => {
        setErrorMsg(null)
        setLoader(true);
        const response = await apiCalls.getCustomerView(id);
        if (response?.ok) {
            setCustomerDetails(response?.data);
            setLoader(false);
        }
        else {
            setErrorMsg(apiCalls.isErrorDispaly(response));
            setLoader(false);
        }
    }
    const breadCrumbList = useMemo(() => [
        { id: '1', bname: 'Customers', url: "/customers" },
        { id: '2', bname: CustomerDetails?.fullName },
        { id: '3', bname: tabName }
    ], [CustomerDetails, tabName]);
    const handleUpload = () => {
        inputRef.current?.click();
    };
    const handleCopy = useCallback((id) => {
        setIsCopied(id);
        setTimeout(() => {
        setIsCopied('');
    }, 500)
    },[])

    const closeErrorHandler=useCallback(()=>{
        setErrorMsg(null)
    },[])
    return (
        <div className=''>
            <div>
                <HeaderComponent breadCrumbList={breadCrumbList} />
            </div>
            {errorMsg && <WarningMessage msg={errorMsg} onClose={closeErrorHandler} />}
            <div>
                <div className='text-center'> <Spin spinning={loader} /></div>
                <div className="border border-StrokeColor md:p-4 p-2 rounded-5 mb-4">
                    <div className='md:flex block gap-4 items-start' >
                        <div className='text-center md:mb-0 mb-3' onClick={handleUpload}>
                            {(CustomerDetails?.imageurl && CustomerDetails?.imageurl !== 'null') ? (
                                <img
                                    className="lg:h-28 lg:w-28 h-28 w-28 mx-auto rounded-full object-cover"
                                    src={`${CustomerDetails?.imageurl}`}
                                    alt="profile image"
                                    style={{ filter: 'blur(20px)' }}
                                    onLoad={(e) => {
                                        e.target.style.filter = 'none';
                                    }}
                                />
                            ) : (
                                <img
                                    className="lg:h-28 lg:w-28 h-28 w-28 mx-auto rounded-full object-cover"
                                    src={defaultAvathar}
                                    alt="profile image"
                                />
                            )}
                            <div className='relative w-fit mx-auto mt-2'>
                                <p className="mb-0 text-valueColor font-xs">
                                    {CustomerDetails?.customerState && <span className={`status-badge px-2 rounded-lg !text-[12px] badge-status badge-bg ${badgeColor[CustomerDetails?.customerState?.toLowerCase()] || "bg-green"}`}>
                                        {CustomerDetails?.customerState}
                                    </span>}
                                </p>
                            </div>
                        </div>
                        <div className='md:flex-1'>
                        <h1 className='text-titleColor mb-2 font-semibold text-xl'>
                              {CustomerDetails?.fullName ? CustomerDetails?.fullName : ""}
                            </h1>
                            <div>
                                <div className='md:flex-1'>
                                    <div className="grid  md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3 gap-4 mt-0">
                                        {<div className="">
                                            <h4 className="summary-value break-words md:w-40 xl:w-full w-full">{CustomerDetails?.email ? CustomerDetails?.email : ""}</h4>
                                            <h4 className="summary-value">{CustomerDetails?.phoneNo ? CustomerDetails?.phoneNo : ""}</h4>
                                            <div className="flex items-center gap-1  whitespace-nowrap">
                                            <h4 className="summary-label">Customer ID: </h4> <CustomerIdCell customerId={CustomerDetails?.customerId} copied={isCopied} handleCopy={handleCopy} />
                                            </div>                                            
                                        </div>}
                                        {<div className="">
                                            <p className="summary-label">Full Name</p>
                                            <p className="summary-value">{CustomerDetails?.fullName ? CustomerDetails?.fullName : ""}</p>
                                        </div>}
                                        {<div className="">
                                            <p className="summary-label">Gender</p>
                                            <p className="summary-value">{CustomerDetails?.gender ? CustomerDetails?.gender : ''}</p>
                                        </div>}                                       
                                        {<div className="mb-3">
                                            <p className="summary-label">Date of Birth</p>
                                            <p className="summary-value">{CustomerDetails?.dob ? moment(CustomerDetails?.dob).format('DD/MM/YYYY') : ""}</p>
                                        </div>}
                                        {<div >
                                            <p className="summary-label">Country</p>
                                            <p className="summary-value">{CustomerDetails?.country ? CustomerDetails?.country : ""}</p>
                                        </div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div className=''>
                    <AppTabsComponent serviceName={"CardsManageService.Customers"} gridId={id} isNoRouting={false} tabPosition='top' />
                </div>
                <div className=''>
                    <Outlet />
                </div>
            </div>
        </div>

    )
}
export default CustomerInfo